<div
  class="string-tuning no-select"
  [ngStyle]="getMainStyle()">
  <ion-icon
    class="icon left"
    [ngStyle]="getIconStyle(false)"
    [style.opacity]="(ldetune <= -MAX_DETUNE) ? .2 : 1"
    name="arrow-back-outline"
    (click)="decrease()"></ion-icon>
  <div 
    class="bar"
    *ngFor="let bar of leftBars"
    [ngStyle]="{
      'height': bar.height + 'px',
      'width': (5 * multi) + 'px',
      'background-color': bar.selected ? 'green' : '#ccc'
    }"
    (click)="decrease()">&nbsp;
  </div>
  <div
    class="tune"
    [ngStyle]="getTuneStyle(ldetune <= 0)"
    (click)="resetTuning()">
    {{ detuneDisplay }}
  </div>
  <span (click)="increase()">
    <span 
      class="bar"
      *ngFor="let bar of rightBars"
      [ngStyle]="{
        'height': bar.height + 'px',
        'width': (5 * multi) + 'px',
        'background-color': bar.selected ? 'red' : '#ccc'
      }">&nbsp;
    </span>
  </span>
  <ion-icon
    class="icon right"
    [ngStyle]="getIconStyle(true)"
    [style.opacity]="(ldetune >= this.MAX_DETUNE) ? .2 : 1"
    name="arrow-forward-outline"
    (click)="increase()"></ion-icon>
</div>